import { render } from "./AdminDataTable.vue?vue&type=template&id=04807a61"
import script from "./AdminDataTable.vue?vue&type=script&lang=js"
export * from "./AdminDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__